import { Url } from "../api_settings/api_constants";
import { wrappedFetch } from "../api_settings/urlFunctions";



// Apply search 
export const applySearch = (data) => {
    return wrappedFetch(Url.APPLY_SEARCH, "POST", data);
};
